import cn from 'clsx';
import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  required: boolean;
  error?: ReactNode;
}

export const EmployeeInput = forwardRef<HTMLInputElement, Props>(({ error, label, className, required, ...inputProps }, ref) => {
  return (
    <div className={'pb-3'}>
      <label className={'body-14 block pb-1 pt-3 text-gray-700'}>
        {label} <span className={cn(required ? 'text-blue-600' : 'text-gray-500')}>{required ? '(필수)' : '(선택)'}</span>
      </label>
      <input
        className={cn(
          'rounded-2.5 sub-title-16 w-full border border-gray-200 px-4 py-3 text-gray-800 placeholder:text-gray-400',
          error && 'border-red-600',
          className
        )}
        {...inputProps}
        ref={ref}
      />
      {error && <p className={'body-13 my-1 text-red-600'}>{error}</p>}
    </div>
  );
});

EmployeeInput.displayName = 'EmployeeInput';
